import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useLocation, useNavigate, NavLink } from 'react-router-dom';
import { Button, Drawer, Grid } from '@mui/material';
import { BrowserView, MobileView, isMobile } from 'react-device-detect';
import Logo from "./logo.png"
import { useState } from 'react';
import { Image } from 'antd';
import Close from '@mui/icons-material/Close';

function TopBar() {
    const navigate = useNavigate()
    const [drawerOpen, setDrawerOpen] = useState(false);

    const location = useLocation();

    const handleMenu = () => {
        setDrawerOpen(true)
    };

    const handleClose = () => {
        setDrawerOpen(false)
    };

    const handleHome = () => {
        navigate("/");
    };

    const isActive = (route) => {
        if (route === "/") {
            return !location.pathname.includes("/about") && !location.pathname.includes("/services") && !location.pathname.includes("/contact")
        } else {
            return location.pathname.includes(route)
        }
    };

    const route = (path) => {
        navigate(path);
        if (isMobile) {
            setDrawerOpen(false)
        }
    }

    const navClass = ({ isActive: active }) =>
        "chainz-nav-link" + (active ? " active" : "");

    const menuItems = <>
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <IconButton onClick={handleClose} aria-label="Close menu" sx={{ backgroundColor: "rgba(34, 211, 238, 0.15) !important" }}><Close sx={{ color: "var(--primaryColor)" }} /></IconButton>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", py: 1 }}>
            <MenuItem sx={{ color: "var(--secColor4)", width: "100%", justifyContent: "center" }} onClick={() => route("/")}>{isActive("/") && "|"}<Typography fontWeight={600} marginX={2}>Home</Typography></MenuItem>
            <MenuItem sx={{ color: "var(--secColor4)", width: "100%", justifyContent: "center" }} onClick={() => route("/services")}>{isActive("/services") && "|"}<Typography fontWeight={600} marginX={2}>Services</Typography></MenuItem>
            <MenuItem sx={{ color: "var(--secColor4)", width: "100%", justifyContent: "center" }} onClick={() => route("/about")}>{isActive("/about") && "|"}<Typography fontWeight={600} marginX={2}>About</Typography></MenuItem>
            <MenuItem sx={{ color: "var(--secColor4)", width: "100%", justifyContent: "center" }} onClick={() => route("/contact")}>{isActive("/contact") && "|"}<Typography fontWeight={600} marginX={2}>Contact</Typography></MenuItem>
            <MenuItem sx={{ color: "var(--secColor4)", width: "100%", justifyContent: "center" }} onClick={() => { window.open('https://tracking.chainzsolutions.com/', '_blank', 'noopener,noreferrer'); handleClose(); }}><Typography fontWeight={600} marginX={2}>Track</Typography></MenuItem>
            <MenuItem sx={{ color: "var(--secColor4)", width: "100%", justifyContent: "center" }} onClick={() => { window.open('https://partner.chainzsolutions.com/', '_blank', 'noopener,noreferrer'); handleClose(); }}><Typography fontWeight={600} marginX={2} textAlign="center">Login to CHAINZ Connect</Typography></MenuItem>
            <Box sx={{ width: "100%", maxWidth: 280, mt: 2, px: 2 }}>
                <Button fullWidth variant="contained" color="primary" component={NavLink} to="/contact" onClick={handleClose}>
                    Get Started
                </Button>
            </Box>
        </Box>
    </>


    return (
        <Box
            className="chainz-topbar"
            sx={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                zIndex: (theme) => theme.zIndex.drawer + 2,
            }}
        >
            <BrowserView>
                <Box component="nav" className="chainz-utility-bar" aria-label="Quick links">
                    <a href="https://tracking.chainzsolutions.com/" target="_blank" rel="noopener noreferrer">Track shipment</a>
                    <a href="mailto:customer.support@chainzsolutions.com">Support</a>
                    <a href="https://partner.chainzsolutions.com/" target="_blank" rel="noopener noreferrer">Login to CHAINZ Connect</a>
                </Box>
                <AppBar position="static" elevation={0} component="header">
                    <Toolbar sx={{ py: 1, px: { xs: 1, sm: 2 }, flexWrap: "wrap", rowGap: 1, alignItems: "center" }}>
                        <Grid container alignItems="center">
                            <Grid item xs={12} sm={3} sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
                                <Image preview={false} src={Logo} width={174} onClick={handleHome} style={{ cursor: "pointer" }} alt="Chainz Solutions" />
                            </Grid>
                            <Grid item xs={12} sm={9} sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "center",
                                flexWrap: "wrap",
                                gap: { xs: 1, sm: 0 },
                            }}>
                                <NavLink to={"/"} className={navClass}><Typography component="span" fontWeight={600} marginX={{ xs: 1, sm: 2 }}>Home</Typography></NavLink>
                                <NavLink to={"/services"} className={navClass}><Typography component="span" fontWeight={600} marginX={{ xs: 1, sm: 2 }}>Services</Typography></NavLink>
                                <NavLink to={"/about"} className={navClass}><Typography component="span" fontWeight={600} marginX={{ xs: 1, sm: 2 }}>About</Typography></NavLink>
                                <NavLink to={"/contact"} className={navClass}><Typography component="span" fontWeight={600} marginX={{ xs: 1, sm: 2 }}>Contact</Typography></NavLink>
                                <Typography component="a" href="https://tracking.chainzsolutions.com/" target="_blank" rel="noopener noreferrer" fontWeight={600} marginX={{ xs: 1, sm: 2 }} sx={{ color: "inherit", textDecoration: "none", cursor: "pointer" }}>Track</Typography>
                                <Typography
                                    component="a"
                                    className="chainz-connect-link"
                                    href="https://partner.chainzsolutions.com/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    fontWeight={600}
                                    sx={{
                                        marginX: { xs: 0.5, sm: 1.5 },
                                        fontSize: { xs: "0.8rem", sm: "0.9rem" },
                                        whiteSpace: { sm: "nowrap" },
                                        textAlign: "center",
                                        maxWidth: { xs: "9rem", sm: "none" },
                                        lineHeight: 1.25,
                                    }}
                                >
                                    Login to CHAINZ Connect
                                </Typography>
                                <Button variant="contained" color="primary" component={NavLink} to="/contact" sx={{ ml: { sm: 0.5 } }}>
                                    Get Started
                                </Button>
                            </Grid>
                        </Grid>
                    </Toolbar >
                </AppBar >
            </BrowserView>
            <MobileView>
                <AppBar position="static" elevation={0} component="header">
                    <Toolbar>
                        <Grid container mt={2} alignItems="center">
                            <Grid item xs={8} sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
                                <Image width={112} height={"auto"} preview={false} src={Logo} onClick={handleHome} style={{ cursor: "pointer", padding: 5 }} alt="Chainz Solutions" />
                            </Grid>
                            <Grid item xs={4} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 1 }}>
                                <Button variant="contained" color="primary" size="small" component={NavLink} to="/contact" sx={{ minHeight: 40, color: "#070b14 !important", "&.active": { color: "#070b14 !important" } }}>
                                    Get Started
                                </Button>
                                <IconButton onClick={handleMenu} aria-label="Open menu" sx={{ backgroundColor: "rgba(34, 211, 238, 0.12) !important" }}><MenuIcon sx={{ color: "var(--primaryColor)" }} /></IconButton>
                            </Grid>
                        </Grid>
                    </Toolbar >
                    <Drawer
                        anchor="top"
                        open={drawerOpen}
                        onClose={handleClose}
                        PaperProps={{
                            sx: {
                                background: "linear-gradient(180deg, #0c1222 0%, #070b14 100%)",
                                borderBottom: "1px solid var(--surfaceBorder)",
                            }
                        }}
                    >
                        <Box sx={{ padding: 2 }}>
                            {menuItems}
                        </Box>
                    </Drawer>
                </AppBar >
            </MobileView>
        </Box>
    );
}

export default TopBar;
